export default defineAppConfig({
    theme: {
        primaryColor: '#3DC172',
        secondaryColor: '#242477',
    },
    ui: {
        header: {
            slots: {
                root: 'bg-[#F7948C] backdrop-blur border-none h-[60px] lg:h-[89px] sticky top-0 z-50 pt-[11px]',
                left: 'lg:flex-1 block items-center gap-1.5',
            }
        },
        navigationMenu: {
            slots: {
                list: 'isolate min-w-0 gap-2.5',
                link: 'navigation-menu-link group relative w-full flex items-center gap-1.5 font-medium text-[18px] !text-[#3D0703] tracking-[2px] before:absolute before:z-[-1] before:rounded-md focus:outline-none focus-visible:outline-none dark:focus-visible:outline-none',
            },
            compoundVariants: [
                {
                    color: 'primary',
                    variant: 'pill',
                    active: true,
                    class: {
                        link: 'text-[#3D0703]',
                        linkLeadingIcon: 'text-[#3D0703] group-data-[state=open]:text-[#3D0703]'
                    }
                },
                {
                    color: 'primary',
                    variant: 'pill',
                    active: false,
                    class: {
                        link: 'text-[#3D0703]',
                        linkLeadingIcon: 'text-[#3D0703] group-hover:text-[#3D0703] group-data-[state=open]:text-[#3D0703]'
                    }
                }
            ]
        },
        dashboardSidebar: {
            slots: {
                root: 'relative hidden lg:flex flex-col min-h-svh min-w-[200px] w-(--width) shrink-0',
            },
        },
        button: {
            slots: {
                base: 'rounded-[100px] font-medium inline-flex items-center disabled:cursor-not-allowed aria-disabled:cursor-not-allowed disabled:opacity-75 aria-disabled:opacity-75 transition-colors uppercase font-bold whitespace-nowrap cursor-pointer',
            },
            variants: {
                size: {
                    md: {
                        base: 'px-6 py-4 text-[14px] lg:text-[21px] leading-[13px] lg:leading-[20px] gap-1.5',
                    }
                }
            },
            compoundVariants: [
                {
                    color: 'primary',
                    variant: 'solid',
                    class: 'text-inverted bg-primary hover:bg-transparent hover:text-primary hover:ring-2 active:bg-transparent active:text-primary active:ring-2 disabled:bg-primary aria-disabled:bg-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary'
                },
                {
                    color: 'primary',
                    variant: 'outline',
                    class: 'ring-2 ring-inset ring-primary text-primary hover:bg-primary hover:text-white active:bg-primary active:text-white disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent focus:outline-none focus-visible:ring-2 focus-visible:ring-primary'
                },
                {
                    color: 'secondary',
                    variant: 'solid',
                    class: 'text-inverted bg-secondary hover:bg-transparent hover:text-secondary hover:ring-2 active:bg-transparent active:text-secondary active:ring-2 disabled:bg-secondary aria-disabled:bg-secondary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-secondary'
                },
                {
                    color: 'secondary',
                    variant: 'outline',
                    class: 'ring-2 ring-inset ring-secondary text-secondary hover:bg-secondary hover:text-white active:bg-secondary active:text-white disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent focus:outline-none focus-visible:ring-2 focus-visible:ring-secondary'
                },
                {
                    color: 'info',
                    variant: 'solid',
                    class: 'text-inverted bg-[#401D03] hover:bg-transparent hover:text-[#401D03] hover:ring-2 active:bg-transparent active:text-[#401D03] active:ring-2 disabled:bg-[#401D03] aria-disabled:bg-[#401D03] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#401D03]'
                },
                {
                    color: 'info',
                    variant: 'outline',
                    class: 'ring-2 ring-inset bg-transparent ring-[#401D03] text-[#401D03] hover:bg-[#401D03] hover:text-white active:bg-[#401D03] active:text-white disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent focus:outline-none focus-visible:ring-2 focus-visible:ring-[#401D03]'
                },
            ]
        },
        switch: {
            slots: {
                root: 'relative flex items-center',
                wrapper: 'ms-4',
            },
            variants: {
                size: {
                    md: {
                        base: 'w-[50px]  cursor-pointer',
                        container: 'h-[30px]',
                        thumb: 'h-[20px] w-[20px] data-[state=checked]:translate-x-[25px] data-[state=checked]:rtl:-translate-x-[25px]',
                        wrapper: 'text-[20px] leading-[20px]'
                    },
                }
            }
        },
        selectMenu: {
            slots: {
                content: 'w-full'
            }
        },
        formField: {
            slots: {
                labelWrapper: 'flex content-center items-center justify-between hidden',
                container: 'mt-0 relative',
            }
        },
        input: {
            slots: {
                base: 'w-full border-0 appearance-none placeholder:text-[#2222224D] focus:outline-none disabled:cursor-not-allowed disabled:opacity-75 transition-colors h-[40px] lg:h-[50px] rounded-[100px]',
            },
            variants: {
                size: {
                    md: {
                        base: 'px-6 py-1.5 text-[14px] placeholder:text-[14px] lg:text-[20px] lg:placeholder:text-[20px] gap-1.5',
                    }
                },
                variant: {
                    outline: 'text-highlighted bg-default ring-0'
                }
            },
            compoundVariants: [
                {
                    color: 'primary',
                    variant: [
                        'outline',
                        'subtle'
                    ],
                    class: 'focus-visible:ring-0'
                },
            ]
        },
        textarea: {
            slots: {
                base: [
                    'w-full border-0 appearance-none placeholder:text-[#2222224D] focus:outline-none disabled:cursor-not-allowed disabled:opacity-75 transition-colors min-h-[200px] rounded-[20px] p-8',
                    'transition-colors'
                ],
            },
            variants: {
                size: {
                    md: {
                        base: 'px-4 py-4 gap-1.5 text-[14px] placeholder:text-[14px] lg:text-[20px] lg:placeholder:text-[20px]',
                    }
                }
            },
            compoundVariants: [
                {
                    color: 'primary',
                    variant: [
                        'outline',
                        'subtle'
                    ],
                    class: 'border-0 ring-0 focus-visible:ring-0'
                },
            ]
        },
        inputDate: {
            slots: {
                base: [
                    'group relative inline-flex items-center rounded-md select-none h-[40px] lg:h-[50px] rounded-[100px]',
                    'transition-colors'
                ],
                trailingIcon: 'shrink-0 size-12 text-muted'
            },
            variants: {
                size: {
                    md: {
                        base: [
                            'px-6 py-1.5 text-[14px] placeholder:text-[14px] lg:text-[20px] lg:placeholder:text-[20px] gap-1.5',
                            'gap-0.5'
                        ],
                        segment: 'data-[segment=day]:w-10 data-[segment=month]:w-10 data-[segment=year]:w-15 uppercase'
                    },
                }
            }
        },
        radioGroup: {
            slots: {
                item: 'flex items-center',
            },
            variants: {
                color: {
                    secondary: {
                        base: 'focus-visible:outline-secondary',
                        indicator: 'bg-transparent after:bg-secondary'
                    }
                },
                indicator: {
                    start: {
                        wrapper: 'ms-4'
                    },
                },
                size: {
                    md: {
                        fieldset: 'gap-y-4',
                        base: 'h-[32px] w-[32px] cursor-pointer',
                        item: 'text-[18px] leading-[26px] tracking-wide',
                        container: 'h-[32px]',
                        indicator: 'after:h-[20px] after:w-[20px]'
                    }
                }
            },
        },
        tabs: {
            slots: {
                root: 'flex items-center gap-4',
                indicator: 'absolute transition-[translate,width] duration-200 border-2 border-[#148744]',
                trigger: [
                    'group relative inline-flex items-center min-w-0 font-black data-[state=inactive]:font-normal rounded-[63px] disabled:cursor-not-allowed disabled:opacity-100',
                    'transition-colors cursor-pointer'
                ],
                label: 'truncate uppercase',
            },
            variants: {
                variant: {
                    pill: {
                        list: 'bg-white rounded-[63px]',
                        trigger: 'grow',
                        indicator: 'rounded-[63px] shadow-xs'
                    },
                },
                size: {
                    md: {
                        trigger: 'px-3 py-1.5 text-sm gap-1.5 h-[34px] lg:h-[50px]',
                    },
                }
            },
            compoundVariants: [
                {
                    color: 'primary',
                    variant: 'pill',
                    class: {
                        indicator: 'bg-transparent border-[#148744]',
                        trigger: 'data-[state=inactive]:text-[#148744] hover:data-[state=inactive]:not-disabled:text-[#148744] data-[state=active]:text-[#148744] text-[#148744] focus-visible:outline-0 focus-visible:outline-offset-0'
                    }
                },
                {
                    color: 'secondary',
                    variant: 'pill',
                    class: {
                        indicator: 'bg-transparent border-secondary',
                        trigger: 'data-[state=inactive]:text-secondary hover:data-[state=inactive]:not-disabled:text-secondary data-[state=active]:text-secondary text-secondary focus-visible:outline-0 focus-visible:outline-offset-0'
                    }
                },
            ]
        },
        accordion: {
            slots: {
                trigger: 'accordion-button group flex-1 flex items-center gap-1.5 font-bold text-[26px] leading-[34px] py-3.5 focus-visible:outline-primary min-w-0',
                content: 'data-[state=open]:animate-[accordion-down_200ms_ease-out] data-[state=closed]:animate-[accordion-up_200ms_ease-out] overflow-hidden focus:outline-none mb-[20px]',
                trailingIcon: 'shrink-0 text-[30px] ms-auto group-data-[state=open]:rotate-180 transition-transform duration-200',
            }
        },
        modal: {
            slots: {
                content: 'fixed bg-default divide-y divide-transparent flex flex-col focus:outline-none',
                header: 'modal-header flex items-center gap-1.5 px-4 pt-4 pb-0 sm:px-6 min-h-2',
                body: 'modal-body flex-1 overflow-y-auto p-4 sm:p-6',
                footer: 'modal-footer flex items-center gap-1.5 p-4 sm:px-6',
            },
            variants: {
                fullscreen: {
                    false: {
                        content: 'top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[calc(100vw-2rem)] max-w-lg max-h-[calc(100dvh-2rem)] sm:max-h-[calc(100dvh-4rem)] rounded-[28px] shadow-lg ring ring-default overflow-hidden'
                    }
                }
            }
        },
        carousel: {
            slots: {
                arrows: 'carousel-arrows',
                prev: 'ring-0 bg-transparent hover:bg-transparent active:bg-transparent cursor-pointer lg:text-[40px]',
                next: 'ring-0 bg-transparent hover:bg-transparent active:bg-transparent cursor-pointer lg:text-[40px]',
                dots: 'carousel-dots absolute inset-x-0 -bottom-9 flex flex-wrap items-center justify-center gap-3',
                dot: [
                    'cursor-pointer h-[18px] w-[18px] md:h-[18px] md:w-[18px] bg-[#F46C62] border-2 border-[#F46C62] rounded-full',
                    'transition'
                ]
            },
            variants: {
                orientation: {
                    horizontal: {
                        prev: 'start-4 sm:-start-4 xl:-start-20 top-1/2 translate-y-1/2',
                        next: 'end-4 sm:-end-4 xl:-end-20 top-1/2 translate-y-1/2'
                    }
                },
                active: {
                    true: {
                        dot: 'data-[state=active]:bg-transparent'
                    }
                }
            }
        },
        footer: {
            slots: {
                root: 'bg-[#030340]',
                top: 'pt-8 lg:pt-8 pb-0 lg:pb-0',
                container: 'py-0 lg:py-0 lg:flex lg:items-center lg:justify-between lg:gap-x-0',
                bottom: 'pt-0 lg:pt-6 pb-6 lg:pb-6',
            }
        }
    }
})
